<div *ngIf="visible" class="dialog">
  <h1 class="dialog-title">{{ dialogTitle }}</h1>
  <div class="dialog-content">
    <ng-content select=".body"></ng-content>
  </div>
  <div class="dialog-buttons">
    <ng-content select=".buttons"></ng-content>
  </div>
</div>

<div *ngIf="visible" class="dialog-overlay"></div>